import { CreateCreditNoteParams, CreateCreditNoteResponse, CreateInvoiceParams, CreateInvoiceResponse, CreditInvoiceParams, CreditInvoiceResponse, DownloadInvoiceParams, DownloadInvoiceResponse, GetInvoiceByIdParams, GetInvoiceByIdResponse, GetInvoiceListParams, GetInvoiceListResponse, MarkAllAsPaidInvoiceParams, MarkAllAsPaidInvoiceResponse, MarkAsPaidInvoiceParams, MarkAsPaidInvoiceResponse, PreviewCreditNoteByIdParams, PreviewCreditNoteByIdResponse, PreviewInvoiceByIdParams, PreviewInvoiceByIdResponse, RaiseInvoiceParams, RaiseInvoiceResponse, SendEmailInvoiceParams, SendEmailInvoiceResponse, SendEmailRaiseInvoiceParams, SendEmailRaiseInvoiceResponse, UpdateInvoiceByIdParams, UpdateInvoiceByIdResponse } from '@nxsys/types/api';
import axios from '../axios';
import { endPoints } from '../endpoints';

export const getInvoiceListApi = async (
  params: GetInvoiceListParams,
): Promise<GetInvoiceListResponse> => {
  const response = await axios.get(endPoints.invoices.main, { params });
  return response.data;
};

export const createInvoiceApi = async (
  params: CreateInvoiceParams,
  options: {
    isBureau: boolean;
  } = {
      isBureau: false,
    },
): Promise<CreateInvoiceResponse> => {
  const { isBureau } = options;
  const response = await axios.post(!isBureau ? endPoints.invoices.create : endPoints.invoices.createBureau, params);
  return response.data;
};

export const getInvoiceByIdApi = async (
  params: GetInvoiceByIdParams,
): Promise<GetInvoiceByIdResponse> => {
  const response = await axios.get(`${endPoints.invoices.main}/${params.id}`);
  return response.data;
};

export const updateInvoiceByIdApi = async (
  params: UpdateInvoiceByIdParams,
): Promise<UpdateInvoiceByIdResponse> => {
  const response = await axios.put(`${endPoints.invoices.edit}/${params.id}`, { rates: params.rates });
  return response.data;
};

export const previewInvoiceByIdApi = async (
  params: PreviewInvoiceByIdParams,
): Promise<PreviewInvoiceByIdResponse> => {
  const response = await axios.put(`${endPoints.invoices.invoicePreviewPdf}/${params.id}`);
  return response.data;
};

export const sendMailInvoiceApi = async (
  params: SendEmailInvoiceParams,
): Promise<SendEmailInvoiceResponse> => {
  const response = await axios.post(endPoints.invoices.sendEmail, params);
  return response.data;
};

export const sendMailBureauInvoiceApi = async (
  params: SendEmailInvoiceParams,
): Promise<SendEmailInvoiceResponse> => {
  const response = await axios.post(endPoints.invoices.sendBureauEmail, params);
  return response.data;
};

export const downloadInvoiceApi = async (
  params: DownloadInvoiceParams,
): Promise<DownloadInvoiceResponse> => {
  const response = await axios.put(endPoints.invoices.download, params.ids);
  return response.data;
};

export const downloadAllInvoiceApi = async (): Promise<{ success: boolean }> => {
  const response = await axios.post(endPoints.invoices.downloadAllInvoice);
  return response.data;
};

export const creditInvoiceApi = async (params: CreditInvoiceParams): Promise<CreditInvoiceResponse> => {
  const response = await axios.put(endPoints.invoices.credited, params);
  return response.data;
};

export const markAsPaidInvoiceApi = async (params: MarkAsPaidInvoiceParams): Promise<MarkAsPaidInvoiceResponse> => {
  const response = await axios.put(endPoints.invoices.payment, params);
  return response.data;
};

export const markAllAsPaidInvoiceApi = async (params: MarkAllAsPaidInvoiceParams): Promise<MarkAllAsPaidInvoiceResponse> => {
  const response = await axios.put(endPoints.invoices.paidAll, params);
  return response.data;
};

export const raiseInvoiceApi = async (
  params: RaiseInvoiceParams,
  options: {
    isBureau: boolean;
  } = {
      isBureau: false,
    },
): Promise<RaiseInvoiceResponse> => {
  const { isBureau } = options;
  const response = await axios.post(!isBureau ? endPoints.invoices.raiseInvoiceByAgency : endPoints.invoices.raiseInvoiceBureau, params);
  return response.data;
};

export const createCreditNoteApi = async (
  params: CreateCreditNoteParams,
  options: {
    isBureau: boolean;
  } = {
      isBureau: false,
    },
): Promise<CreateCreditNoteResponse> => {
  const { isBureau } = options;
  const response = await axios.post(!isBureau ? endPoints.invoices.createCreditNote : endPoints.invoices.createCreditNoteBureau, params);
  return response.data;
};

export const previewCreditNoteByIdApi = async (
  params: PreviewCreditNoteByIdParams,
): Promise<PreviewCreditNoteByIdResponse> => {
  const response = await axios.put(`${endPoints.invoices.creditNotePreviewPdf}/${params.id}`);
  return response.data;
};

export const downloadCreditNoteApi = async (
  params: DownloadInvoiceParams,
): Promise<DownloadInvoiceResponse> => {
  const response = await axios.put(endPoints.invoices.downloadCreditNotes, params.ids);
  return response.data;
};

export const downloadAllCreditNoteApi = async (): Promise<{ success: boolean }> => {
  const response = await axios.post(endPoints.invoices.downloadAllCredit);
  return response.data;
};

export const updateCreditNoteByIdApi = async (
  params: UpdateInvoiceByIdParams,
): Promise<UpdateInvoiceByIdResponse> => {
  const response = await axios.put(`${endPoints.invoices.editCreditNote}/${params.id}`, { rates: params.rates });
  return response.data;
};

export const sendMailRaiseInvoiceApi = async (
  params: SendEmailRaiseInvoiceParams,
): Promise<SendEmailRaiseInvoiceResponse> => {
  const response = await axios.post(`${endPoints.invoices.sendInvoiceEmail}/${params.id}`);
  return response.data;
};